import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab, faGithubSquare } from "@fortawesome/free-brands-svg-icons";

library.add(fas, fab, faGithubSquare);
